import PDFCard from './PDFCard';
import './styles.scss';

const PDFBox = ({ title, data }) => {
    return (
        <div className="box product-box">
            <h3>{title}</h3>
            <div className="pdf-items">
                {data.map(el => (
                    <PDFCard title={el} />
                ))}
            </div>
        </div>
    );
};

export default PDFBox;
